import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row justify-content-between align-items-start mb-3" }
const _hoisted_2 = { class: "description mr-2" }

import { ref, Ref, toRefs } from 'vue';
import InputSwitch from 'primevue/inputswitch';
import GoalsCheckbox from './GoalsCheckbox.vue';
import { TrialGoalInterface } from '@/types';
import { EMIT } from '@/enum';

interface PropsInterface {
  goal: TrialGoalInterface;
  attendeeId: number;
  displayPastEventsModal: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TrialsGoals',
  props: {
    goal: {},
    attendeeId: {},
    displayPastEventsModal: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const { goal, attendeeId, displayPastEventsModal } = toRefs(props);
const showTrialGoals: Ref<boolean> = ref(goal.value.show_goal);

const updateShouldSaveGoals = () => {
  emit(EMIT.SHOULD_SAVE_GOALS, showTrialGoals.value, goal.value.treatment_goal_id, attendeeId.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-column goal-card p-3 mt-3", { disabled: !showTrialGoals.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("b", null, _toDisplayString(_unref(goal).description), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(InputSwitch), {
          modelValue: showTrialGoals.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showTrialGoals).value = $event)),
          class: "mt-1",
          disabled: !!_unref(goal).completed_at,
          onChange: updateShouldSaveGoals
        }, null, 8, ["modelValue", "disabled"])
      ])
    ]),
    (showTrialGoals.value)
      ? (_openBlock(), _createBlock(GoalsCheckbox, {
          key: 0,
          trial: _unref(goal),
          "attendee-id": _unref(attendeeId),
          disabled: !!_unref(goal).completed_at,
          "display-past-events": _unref(displayPastEventsModal)
        }, null, 8, ["trial", "attendee-id", "disabled", "display-past-events"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})